import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class RosterApi {
  // *********************************** //
  // *** ROSTER APIS
  // *********************************** //
  static getAllRosters(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.rosterList, { params });
  }

  static getRoster({ id }) {
    return axios.get(ApiEndpoints.rosterDetail.replace(':id:', id));
  }

  static createRoster(roster) {
    return axios.post(ApiEndpoints.rosterList, roster);
  }

  static saveRoster(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.rosterDetail.replace(':id:', id), data);
  }

  static deleteRoster({ id }) {
    return axios.delete(ApiEndpoints.rosterDetail.replace(':id:', id));
  }

  // *********************************** //
  // *** ROSTER VERSION APIS
  // *********************************** //
  static getRosterVersion({ id }) {
    return axios.get(ApiEndpoints.rosterVersionDetail.replace(':id:', id));
  }

  static deleteRosterVersion({ id }) {
    return axios.delete(ApiEndpoints.rosterVersionDetail.replace(':id:', id));
  }

  static getRosterVersionPublishDetail(id, from, to) {
    return axios.get(
      `${ApiEndpoints.rosterVersionDetail.replace(':id:', id)}?pub&dt_from=${from}&dt_to=${to}`
    );
  }

  static loadRosterVersions(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.rosterVersionList, { params });
  }

  static createRosterVersion(version) {
    return axios.post(ApiEndpoints.rosterVersionList.replace('?parent_roster=:parent_roster:', ''), version);
  }

  static saveRosterVersion(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.rosterVersionDetail.replace(':id:', id), data);
  }

  static publishRoster(id, from, to) {
    return axios.post(
      ApiEndpoints.rosterVersionPublish
        .replace(':id:', id)
        .replace(':from:', from)
        .replace(':to:', to)
    );
  }

  // *********************************** //
  // *** VALIDATION APIS
  // *********************************** //
  static getAllValidators(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.rosterValidatorList, { params });
  }

  static getAllValidations(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.rosterValidationList, { params });
  }

  static getValidationTasks(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.rosterValidationTaskList, { params });
  }

  static createValidationTask(data) {
    return axios.post(ApiEndpoints.rosterValidationTaskList, data);
  }

  static getValidationTask({ id }) {
    return axios.get(ApiEndpoints.rosterValidationTask.replace(':id:', id));
  }

  static getValidation({ id }) {
    return axios.get(ApiEndpoints.rosterValidation.replace(':id:', id));
  }

  static createValidation(data) {
    return axios.post(ApiEndpoints.rosterValidationList, data);
  }

  static editValidation(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.rosterValidation.replace(':id:', id), data);
  }

  static deleteValidation({ id }) {
    return axios.delete(ApiEndpoints.rosterValidation.replace(':id:', id));
  }

  // *********************************** //
  // *** ASSIGNMENT APIS
  // *********************************** //
  static getAssignments(version_id, users, start, end, includeUnassigned) {
    const data = {
      version_id,
      start,
      end,
      users,
      exclude_unallocated: !includeUnassigned
    };
    return axios.post(ApiEndpoints.rosterAssignmentList, data);
  }

  static createUpdateAssignments(items, deleted_item_ids, version_id, start_date, end_date) {
    return axios.patch(ApiEndpoints.rosterAssignmentBulkUpdate.replace(':v:', version_id), {
      items,
      deleted_item_ids,
      start_date,
      end_date
    });
  }
}

export default RosterApi;
